module.exports = __webpack_public_path__ + "img/x-box-image-detail-3.b7892f6b.png";